import _ from 'lodash'
import type { StringKeyed } from '../types/util'

export default class Errors {
	private static instances: StringKeyed<Errors> = {}
	static get(label) {
		return Errors.instances[label]
	}
	static for(label) {
		return Errors.get(label) || (Errors.instances[label] = new Errors(label))
	}

	readonly errors: Error[] = []
	readonly lastOnError

	constructor(readonly label: string) {
		this.lastOnError = window.onerror
		if (typeof window != 'undefined') {
			window.onerror = (msg, url, lineNo, columnNo, error) => {
				const result = this.lastOnError?.(msg, url, lineNo, columnNo, error)
				this.errors.push(error)
				return result
			}
		}
	}

	exec(fn) {
		try {
			fn()
		} catch (e) {
			this.errors.push(e)
		}
		return this
	}

	log(e) {
		this.errors.push(e)
	}

	finish(fn) {
		if (this.lastOnError) window.onerror = this.lastOnError
		delete Errors.instances[this.label]
		fn(this)
	}

	report() {
		if (this.errors.length > 0) alert(this.label + ' Errors: ' + _.uniq(this.errors.map(e => String(e)).join('\n')))
	}
}